import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAlignTopLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.125 4.33167C3.125 3.66517 3.66517 3.125 4.33167 3.125H6.50167C7.16816 3.125 7.70833 3.66517 7.70833 4.33167V15.6683C7.70833 16.3348 7.16816 16.875 6.50167 16.875H4.33167C3.66517 16.875 3.125 16.3348 3.125 15.6683V4.33167ZM4.33167 1.875C2.97482 1.875 1.875 2.97482 1.875 4.33167V15.6683C1.875 17.0252 2.97482 18.125 4.33167 18.125H6.50167C7.85851 18.125 8.95833 17.0252 8.95833 15.6683V4.33167C8.95833 2.97482 7.85851 1.875 6.50167 1.875H4.33167ZM12.2917 4.33167C12.2917 3.66517 12.8318 3.125 13.4983 3.125H15.6683C16.3348 3.125 16.875 3.66517 16.875 4.33167V9.835C16.875 10.5015 16.3348 11.0417 15.6683 11.0417H13.4983C12.8318 11.0417 12.2917 10.5015 12.2917 9.835V4.33167ZM13.4983 1.875C12.1415 1.875 11.0417 2.97482 11.0417 4.33167V9.835C11.0417 11.1918 12.1415 12.2917 13.4983 12.2917H15.6683C17.0252 12.2917 18.125 11.1918 18.125 9.835V4.33167C18.125 2.97482 17.0252 1.875 15.6683 1.875H13.4983Z",
		fill: "currentColor"
	})
});
export default SvgAlignTopLine;
